export default "__VITE_ASSET__P6r6OGpN__"